import { sileo } from 'sileo';

const MONTH_NAMES_ES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const formatPeriodLabel = (period) => {
  const [year, month] = period.split('-').map(Number);
  const monthName = MONTH_NAMES_ES[month - 1] || period;
  return `${monthName} ${year}`;
};

export const notifyBukSyncCompleted = (data) => {
  const months = Array.isArray(data?.months) ? data.months : [];
  const totalWorkers = months.reduce((acc, m) => acc + (m.workers || 0), 0);

  sileo.success({
    title: 'Sincronización con Buk completada',
    description: (
      <div className="flex flex-col gap-1">
        <span className="text-green-600 font-medium">
          {months.length} {months.length === 1 ? 'mes sincronizado' : 'meses sincronizados'} · {totalWorkers} trabajadores en total
        </span>
        {months.length > 0 && (
          <ul className="text-xs text-slate-500 list-disc list-inside max-h-32 overflow-y-auto">
            {months.map((m) => (
              <li key={m.period}>
                {formatPeriodLabel(m.period)}: {m.workers > 0 ? `${m.workers} trabajadores` : (m.message || 'sin datos')}
              </li>
            ))}
          </ul>
        )}
      </div>
    ),
  });
};

export const notifyBukSyncError = (data) => {
  sileo.error({
    title: 'Error en la sincronización con Buk',
    description: data?.error || 'Ocurrió un error durante la sincronización con Buk.',
  });
};
